<template>
  <div>
    <a
      @click="$emit('updateRoute')"
      class="fp-item__detailLink button"
      aria-haspopup="true"
      :title="$t('list.linkToDetailTooltip')"
      :style="{'width': view_size_mode <= 2 ? '100%' : '210px'}"
      :class="{'ed-item__detailLink': show_favourite && !terminalmode, 'fp-item__detailLink--terminalMode': terminalmode}">
      {{ $t('list.linkToDetail') }}
    </a>
    <template v-if="show_favourite">
      <button
        @click="$emit('setFavourite')"
        class="ed-item__favourite button"
        v-if="!terminalmode"
        :class="{ 'ed-item__favourite--active': is_favourite }"
        :aria-pressed="is_favourite"
        :title="
          is_favourite ?
          $t('list.favouriteTooltip.detail.active') : $t('list.favouriteTooltip.detail.inactive')">
        <i class="icon icon-star"></i>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    terminalmode: {
      type: Boolean,
      default: false,
    },
    show_favourite: {
      type: Boolean,
      default: false,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    is_favourite: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.fp-item__detailLink {
  width: 210px;
  position: absolute;
  right: -1px;
  bottom: 0;
  padding: 10px 0;
}
.fp-item__detailLink--terminalMode {
  position: relative;
  margin-right: 0;
}
</style>
